import {getAxiosInstance, rethrowErrorWithMessage} from '../helpers/axios-helper'
import { validateTeamCreation } from '../helpers/team-helper'

const baseUrl = process.env.BACKEND_URL
console.log(' > baseUrl:', baseUrl)

function getTeams(gameId) {
  console.log('calling teams service')
  return getAxiosInstance().get(`${baseUrl}/games/${gameId}/teams`)
    .then(teamsResult => {
      return teamsResult.data
    })
    .catch(err => {
      console.error(err)
      throw err
    })
}

function getTeamById(gameId, teamId) {
  return getAxiosInstance().get(`${baseUrl}/games/${gameId}/teams/${teamId}`)
    .then(teamsResult => {
      return teamsResult.data
    })
    .catch(err => {
      console.error(err)
      throw err
    })
}

function createTeam(team, game, photoToUpload, gameId) {
  const errors = validateTeamCreation(team, photoToUpload)
  if (errors.length) {
    console.log('validation failed')
    return {
      isSuccess: false,
      errors
    }
  }

  const image = photoToUpload ? {
    data: photoToUpload.replace(/^data:image\/\w+;base64,/, ''),
    extension: photoToUpload.split(';')[0].split('/')[1]
  } : null

  return getAxiosInstance().post(`${baseUrl}/games/${gameId}/teams`, {
    team,
    game,
    image,
  })
    .then(teamsResult => {
      console.log('Team created')
      console.log(teamsResult.data)
      return {
        isSuccess: true,
        data: teamsResult.data
      }
    })
    .catch(err => {
      console.log(err)
      return {
        isSuccess: false,
        errors: ['An internal error happened']
      }
    })
}

// TODO: TO REFACTOR = CREATE TEAM WITH A PARAMETER
function updateTeam(team, game, photoToUpload, gameId) {
  const errors = validateTeamCreation(team, photoToUpload)
  if (errors.length) {
    console.log('validation failed')
    return {
      isSuccess: false,
      errors
    }
  }

  const image = {}
  if (photoToUpload.startsWith('http')) {
    image.imageUrl = photoToUpload
  } else {
    image.data = photoToUpload.replace(/^data:image\/\w+;base64,/, '')
    image.extension = photoToUpload.split(';')[0].split('/')[1]
  }

  const teamId = team.teamId

  return getAxiosInstance().put(`${baseUrl}/games/${gameId}/teams/${teamId}`, {
    team,
    game,
    image,
    gameId,
  })
    .then(teamsResult => {
      console.log('Team updated')
      console.log(teamsResult.data)
      return {
        isSuccess: true,
        data: teamsResult.data
      }
    })
    .catch(err => {
      console.log(err)
      return {
        isSuccess: false,
        errors: ['An internal error happened']
      }
    })
}

function deleteTeam(teamId, gameId) {
  return getAxiosInstance().delete(`${baseUrl}/games/${gameId}/teams/${teamId}`)
    .then((data) => data)
    .catch(err => {
      if (err.response.status === 403) {
        throw new Error(err.response.data.message)
      } else {
        throw new Error('Sorry we are unable to serve your request :(')
      }
    })
}

function resetFingerprint(teamId, gameId) {
  return getAxiosInstance().patch(`${baseUrl}/games/${gameId}/teams/${teamId}/resetFingerprint`)
    .then((data) => data)
    .catch(err => {
      if (err.response.status === 403) {
        throw new Error(err.response.data.message)
      } else {
        throw new Error('Sorry we are unable to serve your request :(')
      }
    })
}

function resetAllFingerPrints(gameId) {
  return getAxiosInstance().patch(`${baseUrl}/games/${gameId}/resetFingerprint`)
      .then((data) => data)
      .catch(err => {
        if (err.response.status === 403) {
          throw new Error(err.response.data.message)
        } else {
          throw new Error('Sorry we are unable to serve your request :(')
        }
      })
}

function getTeamPhotos(gameId, teamId) {
  console.log('calling getTeamPhotos')
  return getAxiosInstance().get(`${baseUrl}/games/${gameId}/photos`)
    .then(teamsResult => {
      return teamsResult.data
    })
    .catch(err => {
      console.error(err)
      throw err
    })
}

export default {
  getTeams,
  createTeam,
  deleteTeam,
  resetFingerprint,
  resetAllFingerPrints,
  getTeamPhotos,
  getTeamById,
  updateTeam
}
